import { StorageIds } from '../constants/storage'

export const setSessionData = <
  T extends {
    sessionToken: string
    sessionId: string
  },
>(
  data?: T,
) => {
  data?.sessionToken && localStorage.setItem(StorageIds.sessionToken, data.sessionToken)
  data?.sessionId && localStorage.setItem(StorageIds.sessionId, data.sessionId)
}

export const getSessionToken = () => {
  return localStorage.getItem(StorageIds.sessionToken) || ''
}

export const getSessionId = () => {
  return localStorage.getItem(StorageIds.sessionId) || ''
}
